__turbopack_context__.v({
  "name": "CapacityConflictSummaryRow-module-scss-module__4_GsLa__name",
  "row": "CapacityConflictSummaryRow-module-scss-module__4_GsLa__row",
});
